import { api } from "@/app/services/api.service";

const state = {
    restorations: [],
    responses: [],
    escalations: [],
    restorationStatuses: [],
    restoration: {},
    restoration_stats: {
        pending: 0,
        rejected: 0,
        assigned: 0,
        total: 0,
        approved: 0,
        queried: 0
    },
    restoration_ext_stats: {
        pending: 0,
        approved: 0,
        rejected: 0
    },
    restorationFinalDecision: null,
    restorationFinalDecisionError: null,
    restoration_count: {},
    restoration_result: {},
    analysis: {},
    success: {},
    successAssignment: {},
    errorAssignment: null,
    successEscalation: {},
    error: {},
    fetch_error: null,
    analysis_error: {},
    restorationRevert: null,
    payment_removed: null,
    payment_removed_error: null,

};

const getters = {
    getRestorationSubmissions: (state) => state.restorations,
    getRestorationRevertSuccess: (state) => state.restorationRevert,
    getRestorationResponses: (state) => state.responses,
    getRestorationEscalations: (state) => state.escalations,
    getRestorationEscalationsMenu: (state) => state.escalations_menu,
    getRestorationTask: (state) => state.restoration,
    getRestorationStatistics: (state) => state.restoration_stats,
    getRestorationStatuses: (state) => state.restorationStatuses,
    getRestorationsCount: (state) => state.restoration_count,
    getRestorationAnalysisReport: (state) => state.analysis,
    getRestorationSuccess: (state) => state.success,
    getRestorationEscalationSuccess: (state) => state.successEscalation,
    getRestorationAssignmentSuccess: (state) => state.successAssignment,
    getRestorationActionSuccess: (state) => state.restorationFinalDecision,
    getRestorationActionError: (state) => state.restorationFinalDecisionError,
    getRestorationAssignmentError: (state) => state.errorAssignment,
    getRestorationError: (state) => state.error,
    getRestorationFetchError: (state) => state.fetch_error,
    getRestorationEscalationError: (state) => state.error,
    getRestorationAnalysisReportError: (state) => state.analysis_error,
    getRestorationNumberResult: (state) => state.restoration_result,
    getRestorationNumberResultError: (state) => state.error,
    getRestorationPaymentRemoved: (state) => state.payment_removed,
    getRestorationPaymentRemovedError: (state) => state.payment_removed_error,
};

const actions = {
    async saveRestoration({ commit }, data) {
        await api().post("restoration", data)
            .then((response) => {
                commit("setRestoration", response);
            })
            .catch((error) => {
                commit("setRestorationError", error.response);
            });
    },
    // async fetchRestorations({commit}, data){
    //     let path = "/incorporation/restorations?status="+data.statuses+"&page="+data.page+"&per_page="+data.limit
    //     if(data.search !== ""){
    //         path += "&search="+data.search
    //     }
    //     api().get(path).
    //     then(response => {
    //         commit('setRestorations', response.data);
    //     }).catch(error => {
    //         commit("setRestorationFetchError", error.response)
    //     });
    // },
    async fetchRestorations({ commit }, data) {
        await api().get("/incorporation/restorations?status=" + data.statuses + "&page=" + data.page + "&pageSize=" + data.limit)
            .then(response => {
                commit("setRestorations", response);
            }).catch(error => {
                commit("setRestorationFetchError", error.response);
            });
    },
    async fetchRestorationEscalations({ commit }, data) {
        api().get("/restoration/escalation?status=" + data.status + "&page=" + data.page + "&perPage=" + data.limit).
            then(response => {
                commit('setRestorationEscalations', response.data);
            }).catch(error => {
                commit("setRestorationEscalationError", error.response)
            });
    },
    async fetchRestorationEscalationsMenu({ commit }, data) {
        api().get("/restoration/escalation?status=" + data.status + "&page=" + data.page + "&perPage=" + data.limit).
            then(response => {
                commit('setEscalationsMenu', response.data);
            }).catch(error => {
                commit("setRestorationEscalationError", error.response)
            });
    },
    async revertRestoration({ commit }, restorationNumber) {
        await api().post("restorations/task/status/revert?trackingNo=" + restorationNumber)
            .then((response) => {
                commit("setRestorationReverted", response);
            })
            .catch((error) => {
                commit("setRestorationResultsError", error.response);
            });
    },
    async fetchRestorationStatuses({ commit }, id) {
        api().get("/incorporation/restorations/task/status?restorationId=" + id).
            then(response => {
                commit('setRestorationStatuses', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    // async fetchNextRestoration({ commit }) {
    //     commit('setRestorationToNull');
    //     // api().get("/incorporation/restorations/task/next").
    //     api().post("/incorporation/restorations/task/next").
    //         then(response => {
    //             commit('setRestoration', response.data);
    //         }).catch(error => {
    //             commit("setRestorationError", error.response)
    //         });
    // },
    async fetchNextRestoration({ commit }) {
    commit('setRestorationToNull');
    await api().get("/incorporation/restorations/task/next")
        .then(response => {
            // Force flat structure
            const task = response?.data?.data || response?.data || response;
            commit('setRestoration', task);
        })
        .catch(error => {
            commit("setRestorationError", error.response);
        });
},
    async fetchRestorationByTrackingNumber({ commit }, trackingNumber) {
        commit('setRestorationToNull');
        api().get("/incorporation/restorations/task/next/" + trackingNumber).
            then(response => {
                commit('setRestoration', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    async fetchRestorationStats({ commit }) {
        api().get("incorporation/restorations/task/basic-statistics").
            then(response => {
                commit('setRestorationStats', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    async fetchRestorationCount({ commit }) {
        api().get("incorporation/restorations/task/count").
            then(response => {
                commit('setRestorationCount', response);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    async fetchAnalysisReport({ commit }, names) {
        api().post("/namesearch/analysis-report", { names: names }).
            then(response => {
                commit('setAnalysisReport', response.data);
            }).catch(error => {
                commit("setAnalysisReportError", error.response)
            });
    },
    emptyAnalysisReport({ commit }) {
        commit('setAnalysisReport', null);
    },
    updateRestorationStatus({ commit }, data) {
        api().post("/incorporation/restorations/task/status", data).
            then(response => {
                commit('setRestorationActionSuccess', response.data);
            }).catch(error => {
                commit("setRestorationActionError", error.response)
            });
    },
    extendRestoration({ commit }, data) {
        api().post("/restoration/extension/status", data).
            then(response => {
                commit('setRestorationAction', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    assignRestorationTask({ commit }, data) {
        api().post("/incorporation/restoration/task/manual-assign", data).
            then(response => {
                commit('setRestorationAssignmentAction', response.data);
            }).catch(error => {
                commit("setRestorationAssignmentError", error.response)
            });
    },
    assignEscalationRestorationTask({ commit }, data) {
        api().post("/incorporation/restoration/task/manual-assign", data).
            then(response => {
                commit('setRestorationAssignmentAction', response.data);
            }).catch(error => {
                commit("setRestorationAssignmentError", error.response)
            });
    },
    escalateRestorationTask({ commit }, data) {
        api().post("/restoration/escalation", data).
            then(response => {
                commit('setRestorationEscalationAction', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    reEscalateRestorationTask({ commit }, data) {
        api().post("/restoration/escalation/re", data).
            then(response => {
                commit('setRestorationEscalationAction', response.data);
            }).catch(error => {
                commit("setRestorationError", error.response)
            });
    },
    async fetchRestorationNumberDetails({ commit }, restorationNumber) {
        api().get("/restoration/approved?restorationNo=" + restorationNumber).
            then(response => {
                commit('setRestorationNumberDetails', response.data.data);
            }).catch(error => {
                commit("setRestorationDetailsError", error.response.data)
            });
    },
    async fetchRestorationDetails({ commit }, restorationNumber) {
        api().get("/restoration/by-tracking-no?trackingNo=" + restorationNumber).
            then(response => {
                commit('setRestorationNumberDetails', response.data);
            }).catch(error => {
                commit("setRestorationDetailsError", error.response)
            });
    },
    async fetchRestorationInfo({ commit }, data) {
        await api().get("/restoration/draft?trackingNumber=" + data)
            .then((response) => {
                commit("setRestorationDraftInfo", response);
            })
            .catch((error) => {
                commit("setEntityTypeError", error.response);
            });
    },
    async fetchRestorationResponses({ commit }) {
        api().get("/configuration/appeal-message/all").
            then(response => {
                commit('setRestorationResponses', response.data);
            }).catch(error => {
                commit("setRestorationResponseError", error.response)
            });
    },
    async removePaymentFromRestorationApplication({ commit }, tNo) {
        api().post("/restoration/remove-payment?trackingNo=" + tNo).
            then(response => {
                commit('setRemovePaymentDetails', response.data);
            }).catch(error => {
                commit("setRemovePaymentDetailsError", error.response)
            });
    },
};

const mutations = {
    // setRestorations: (state, response) =>{
    //     state.restorations = response.data;
    // },
    setRestorations: (state, response) => {
        state.restorations = response.data.data || response.data;
    },
    setRestorationResponses: (state, response) => {
        state.responses = response;
    },
    setRestorationResponseError: (state, response) => {
        state.error = response.data;
    },
    setRestorationEscalations: (state, response) => {
        state.escalations = response;
        state.escalations_menu = response;
    },
    setRestoration: (state, task) => {
        state.restoration = task;
    },
    setRestorationToNull: (state) => {
        state.restoration = {};
    },
    setRestorationStatuses: (state, response) => {
        state.restorationStatuses = response;
    },
    setRestorationStats: (state, response) => {
        state.restoration_stats = response;
    },
    setRestorationExtStats: (state, response) => {
        state.restoration_ext_stats = response;
    },
    setRestorationCount: (state, response) => {
        state.restoration_count = response.data;
    },
    setRestorationAction: (state, response) => {
        state.success = response;
    },
    setAppealAction: (state, response) => {
        state.success = response;
    },
    setRestorationAssignmentAction: (state, response) => {
        state.successAssignment = response;
    },
    setRestorationActionSuccess: (state, response) => {
        state.restorationFinalDecision = response;
    },
    setRestorationActionError: (state, response) => {
        state.restorationFinalDecisionError = response;
    },
    setRestorationEscalationAction: (state, response) => {
        state.successEscalation = response;
    },
    setAnalysisReport: (state, response) => {
        state.analysis = response
    },
    setRestorationError: (state, error) => {
        state.error = error;
    },
    setRestorationFetchError: (state, error) => {
        state.fetch_error = error;
    },
    setRestorationEscalationError: (state, error) => {
        state.error = error;
    },
    setRestorationAssignmentError: (state, error) => {
        state.errorAssignment = error;
    },
    setAnalysisReportError: (state, error) => {
        state.analysis_error = error;
    },
    setRestorationNumberDetails: (state, response) => {
        state.restoration_result = response;
    },
    setRestorationDraftInfo: (state, response) => {
        state.restoration_result = response;
    },
    setRestorationReverted: (state, response) => {
        state.restorationRevert = response.data;
    },
    setRemovePaymentDetails: (state, response) => {
        state.payment_removed = response.data
    },
    setRemovePaymentDetailsError: (state, response) => {
        state.payment_removed_error = response.data
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};